import * as React from 'react';

export interface Vehicle {
    id: string;
    alive: boolean;
    type: number;
    timestamp: string;
    position: {
        crs: "wgs84";
        x: number;
        y: number;
        z?: number;
    };
    subtype?: number;
    velocity?: {
        bearing?: number;
        speed?: number;
    };
    service?: {
        route_id?: string;
        trip_id?: string;
        stop_id?: string;
        stop_sequence?: number;
        stop_status?: number;
    };
    delay?: number;
}

let vehicles: {
    [key: string]: Vehicle;
} = {};

let change_listeners: (() => void)[] = [];

export function updateVehicles(vehicles_update: Vehicle[]) {
    vehicles = Object.assign({}, vehicles);
    vehicles_update.forEach((vehicle) => {
        vehicles[vehicle.id] = vehicle;
    });
    change_listeners.forEach(cb => cb());
}

export default function (
    WrappedComponent: typeof React.Component,
): typeof React.Component {
    class VehiclesHOC extends React.Component<any, any> {

        changeListener: () => void;

        constructor(props: any) {
            super(props);

            this.changeListener = () => {
                this.forceUpdate();
            };
        }

        componentDidMount() {
            change_listeners.push(this.changeListener);
        }

        componentWillUnmount() {
            let index = change_listeners.findIndex(listener => listener === this.changeListener);
            if (index > -1) {
                change_listeners.splice(index, 1);
            }
        }

        render() {
            return <WrappedComponent vehicles={vehicles} {...this.props} />;
        }
    }

    return VehiclesHOC;
}


// WEBPACK FOOTER //
// ./src/VehiclesHOC.tsx